module.exports = __webpack_public_path__ + "static/media/bombolulu_bedsitters1.de6c40ab.webp";